import React from "react";
import {dayMonthYearAtTimeWithSeconds} from "../../utils/dates";
import {Col, Row, Button} from "react-bootstrap";
import UserService from "../../services/UserService";
import TransactionService from "../TransactionService";
import Notify from "../../services/Notify";
import TransactionGridFilter from "./TransactionGridFilter";
import moment from "moment";
import {TransactionStatusTranslate} from "../../component/Transaction/TransactionStatusTranslate";

class GridTransactions {

  title = 'Lista de Transações';
  customFilters = {};

  showPdfButton = false;
  exportNewPage = true;

  customButton = (state, props) => (<Button className="pull-right" onClick={() => {
    console.log(props);
    props.history.push('/list/pending-transactions')
  }} title="Pendentes">
    Pendentes
  </Button>);

  customFilterComponent = (props, state, onChange) => {
    return <TransactionGridFilter {...props}
                                  onChange={value => {
                                    this.customFilters = value;
                                    onChange(value);
                                  }}/>
  };

  columns = [
    // {
    //   Header: "ID da leitura",
    //   accessor: "id"
    // },
    {
      Header: "Data",
      accessor: "createdAt",
      Cell: row => dayMonthYearAtTimeWithSeconds(row.original.createdAt)
    },
    {
      Header: "Ponto de Leitura",
      accessor: "readpoint.friendlyName",
      Cell: row => <p>{row.original.readpoint && row.original.readpoint.friendlyName || ''}</p>
    },
    {
      Header: "Ponto de Controle",
      accessor: "checkpoint.friendlyName"
    },
    {
      Header: "Total de Produtos",
      width: 150,
      accessor: "totalAssets"
    },
    {
      Header: 'Local',
      accessor: 'targetLocation.description',
    },
    {
      Header: "Status",
      width: 120,
      accessor: "status",
      Cell: row => <p>{row.original.status && TransactionStatusTranslate(row.original.status) || ''}</p>
    },
    {
      Header: "Ordem de movimentação",
      accessor: "movementOrder.code",
      Cell: row => row.original.movementOrder && row.original.movementOrder.code
    },
    {
      Header: "Usuário",
      accessor: "userCreatedBy.name",
      Cell: row => <p>{row.original.user ? row.original.user.name : (row.original.userCreatedBy && row.original.userCreatedBy.name)}</p>
    },
    {
      Header: "Opções",
      sortable: false,
      filterable: false,
      export: false,
      Cell: row => (
          <Row className="justify-content-around">
            <Col sm={6}>
              <Button bsStyle="success" href={`#/transactions/${row.original.id}`}>Visualizar</Button>
            </Col>
            <Col sm={6}>
              {UserService.isSuper() ?
                  <Button bsStyle="info" block onClick={(e) => {
                    e.preventDefault();
                    Notify.showLoading('Enviando...');
                    new TransactionService().reprocess(row.original.id).then(() => {
                      Notify.success('Está mensagem vai ser reprocessada');
                    }, error => {
                      Notify.error('Falha ao tentar reprocessar está mensagem', error);
                    })
                  }
                  }>
                    Reprocessar
                  </Button> :
                  ''
              }
            </Col>
          </Row>
      )
    }
  ];
  endpoint = (props, state) => {
    const params = new URLSearchParams({});
    this.customFilters.transactionStatus && params.append('_status', this.customFilters.transactionStatus);
    this.customFilters.readpoint && params.append('readpointIds', this.customFilters.readpoint);
    this.customFilters.user && params.append('userIds', this.customFilters.user);
    this.customFilters.bizLocation && params.append('bizLocationIds', this.customFilters.bizLocation);
    this.customFilters.checkpoint && params.append('checkpointIds', this.customFilters.checkpoint);
    this.customFilters.productType && params.append('transactionItems.productTypeId', this.customFilters.productType.id);
    this.customFilters.movementOrder && params.append('movementOrderIds', this.customFilters.movementOrder);

    if (!this.customFilters.startDate) {
      this.customFilters.startDate = moment().subtract(1, 'days').toDate();
    }

    if (!this.customFilters.endDate) {
      this.customFilters.endDate = new Date();
    }

    this.customFilters.startDate && params.append('startDate', this.customFilters.startDate.toISOString());
    this.customFilters.endDate && params.append('endDate', this.customFilters.endDate.toISOString());
    return "ton/v1/transactions?" + params.toString();
  };
}

export default GridTransactions;



// WEBPACK FOOTER //
// ./src/transaction/component/TransactionGrid.js